import React from 'react'
import styles from './home.module.css';
import homeGraph from '../../Assest/img/homeGraph.svg';
import homeUp from '../../Assest/img/homeUp.svg';
import homeManageInventory from '../../Assest/img/homeManageInventory.svg'
import homeEcom from '../../Assest/img/homeEcom.svg';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'

function Home() {
  const navigate = useNavigate();
  
  
  const handleManageInventory = () => {
    navigate('/manageInventory')
  }
  return (
     <div className={styles.container}>

      <div className={styles.cardContainer}>
        <div className={styles.home}>

          <div className={styles.box3}  onClick={handleManageInventory}>
            <div className={styles.up}>
              <img src={homeManageInventory}></img>
              <img src={homeGraph}></img>
            </div>
            <div className={styles.down}>
              <p>10</p>
              <p>Manage Inventory</p>
            </div>
          </div>

        


          <div className={styles.box4} onClick={() => navigate('/ecom')}>
            <div className={styles.up}>
              <img src={homeEcom}></img>
              <img src={homeGraph}></img>
            </div>
            <div className={styles.down}>
              <p>10</p>
              <p>E-com</p>
            </div>
          </div>
        </div>
        

        </div>
          </div>
  )
}

export default Home


